import { Injectable } from '@angular/core';

import * as firebase from 'firebase';
import {AngularFireDatabase} from "angularfire2/database";
import { UserData } from '../providers/user-data';
import { Upload } from '../services/upload';

import {  AngularFireAuthModule, AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../services/auth';
import {AngularFireModule} from "angularfire2";
import {Logger} from "@ionic/app-scripts/dist/logger/logger";
import {LogService} from "./logger";


@Injectable()
export class UploadService {

    private basePath:string = '/uploads';
    uploads: any;
    constructor(
        private db: AngularFireDatabase,
        private userData: UserData,
        private logService: LogService
    ) {

    }

    pushUpload(upload: Upload) {

        this.basePath = this.userData.getUploadRoot();
        var that = this;

        let storageRef = firebase.storage().ref();
        /*var name;
        if(upload.document_type) {
            name = Date.now()+'-'+upload.document_type+'-'+upload.file.name;
        }
        upload.file['name'] = name;*/
        let uploadTask = storageRef.child(`${this.basePath}/${upload.file.name}`).put(upload.file);

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
            (snapshot: any) =>  {
                // upload in progress
                upload.progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100 );

            },
            (error) => {
                // upload failed
                that.logService.error("Upload Error",error);
            },
            () => {
                // upload success
                upload.url = uploadTask.snapshot.downloadURL
                upload.name = upload.file.name
                this.saveFileData(upload)
            }
        );
        return uploadTask;
    }
    pushAsString(name,upload: Upload) {

        this.basePath = this.userData.getUploadRoot();

        let storageRef = firebase.storage().ref();
        var that = this;
        let uploadTask = storageRef.child(`${this.basePath}/${name}`).putString(upload.b64, 'data_url');

        upload.name = name;
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
            (snapshot: any) =>  {
                // upload in progress
                upload.progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100 );

            },
            (error) => {
                // upload failed
                that.logService.error("Upload Error",error);
            },
            () => {
                // upload success
                upload.url = uploadTask.snapshot.downloadURL
                //upload.name = upload.file.name
                this.saveFileData(upload)
            }
        );
        return uploadTask;
    }

    // Writes the file details to the realtime db
    private saveFileData(upload: Upload) {
        upload.type = 'firebase';
        upload.b64="";
        if(upload.document_type) {
            if(upload.specific_root)
                this.db.object(upload.specific_root + "/" + upload.document_type).set(upload);
            else
                this.db.object(this.basePath + "/" + upload.document_type).set(upload);
        }
        else
        {
            if(upload.specific_root)
                this.db.list( upload.specific_root ).push(upload);
            else
                this.db.list( this.basePath ).push(upload);
        }

    }
}


// WEBPACK FOOTER //
// ./src/services/upload-service.ts